// We've changed the query key from referrerScreen to utm_content
// to prevent google indexing the pages with query params as duplicate pages
export const referrerScreenQueryKey = 'utm_content'
